module.exports = __webpack_public_path__ + "static/romazo-c9e690dcff348e8484bfa940c32cf1dc.jpg";